import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { InspectorProps } from "@app/components/WidgetStudio/Inspector/contracts/InspectorProps";
import { CategorySchema } from "@app/components/WidgetStudio/Inspector/inspectors/Posting/categorySchema";
import {
  useGetStoriesByIds,
  useGetOnlyStoriesNotIncludeRelationData,
} from "@shortsworks/user-api";
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useModal,
} from "@shortsworks/ui";
import { Image, ImagePlus, RotateCw, Trash2, Info } from "lucide-react";
import { useEffect, useState } from "react";
import { PostingList } from "@app/components/PostingList";
import { PostingSelectorModal } from "@app/components/modals/PostingSelectorModal";
import {
  CommonSelectModal,
  CommonModal,
} from "@app/components/modals/CommonModal";

export interface PostingInspectorProps extends InspectorProps {}
// 기존의 포스팅의 경우 고정
export const PostingInspector = ({
  defaultFormValues,
  onValueChange,
}: PostingInspectorProps) => {
  const { showModal } = useModal();

  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [innerSelectedIds, setInnerSelectedIds] = useState<string[]>([]);
  const isEmptySelectedIds = innerSelectedIds.length === 0;

  const { data: storiesData } = useGetOnlyStoriesNotIncludeRelationData();
  const selectedStories =
    storiesData?.data.filter((story) => selectedIds.includes(story.id)) ?? [];

  // 카테고리 관련 폼
  const {} = useFormWithSchema({
    formSchemas: CategorySchema,
  });

  const handleClickAddPostings = async () => {
    const modalResult = await showModal<any, string[]>(PostingSelectorModal, {
      title: "포스팅 추가",
      description: "추가할 포스팅을 선택해주세요.",
      selectedIds,
    }).promise();
    if (!modalResult.value || modalResult.value.length < 1) return;
    // merge 형태로 변경 필요
    return setSelectedIds([...selectedIds, ...modalResult.value]);
  };

  useEffect(() => {
    onValueChange({
      postingIds: selectedIds,
    });
  }, [selectedIds]);

  // 초기 데이터 가져오기
  useEffect(() => {
    if(defaultFormValues.postingIds) {
      setSelectedIds(defaultFormValues.postingIds)
    }
  }, []);

  const handleClickRemovePostings = async () => {
    const modalResult = await showModal(CommonSelectModal, {
      title: "선택된 포스팅들을 삭제하시겠습니까?",
    }).promise();
    if (!modalResult.value) {
      return;
    }

    setSelectedIds((prevIds) =>
      prevIds.filter((id) => !innerSelectedIds.includes(id)),
    );
    return setInnerSelectedIds([]);
  };

  const handleSelectPostings = (newSelectedIds: string[]) => {
    return setInnerSelectedIds(newSelectedIds);
  };

  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex items-center justify-between flex-0">
        <div></div>
        <div className="flex">
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                size="icon"
                variant="ghost"
                className="h-7 w-7"
                onClick={handleClickAddPostings}
              >
                <ImagePlus />
              </Button>
            </TooltipTrigger>
            <TooltipContent>포스팅 추가</TooltipContent>
          </Tooltip>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                disabled={isEmptySelectedIds}
                size="icon"
                variant="ghost"
                className="h-7 w-7"
                onClick={handleClickRemovePostings}
              >
                <Trash2 />
              </Button>
            </TooltipTrigger>
            <TooltipContent>삭제</TooltipContent>
          </Tooltip>
        </div>
      </div>

      <div className="flex-1 overflow-hidden">
        <PostingList
          data={selectedStories}
          gridCols={3}
          hideMoreMenu
          onSelect={handleSelectPostings}
          selectedIds={innerSelectedIds}
        />
      </div>
    </div>
  );
};
